/*
 *
 * Adjustments reducer
 *
 */
import produce from 'immer';

import {
  DEFAULT_PG_MENU_TAB_STATE,
  DEFAULT_CURRENT_PAGE,
} from 'utils/constants';
import {
  DEFAULT_ACTION,
  RESET_FILTERS,
  RESET_PAGE,
  SAVE_ADJUSTMENTS,
  UPDATE_FILTERS,
  UPDATE_TABLE_DATA,
  SAVE_VENDOR_DATA_BY_ID,
  ENABLE_LOADER,
  DISABLE_LOADER,
} from './constants';

const getDefaultFilterState = () => ({
  ...DEFAULT_PG_MENU_TAB_STATE,
});

const getInitialState = () => ({
  isLoading: false,
  ...getDefaultFilterState(),
});

export const initialState = {
  ...getInitialState(),
};

/* eslint-disable default-case, no-param-reassign */
const adjustmentsReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case SAVE_ADJUSTMENTS: {
        const { data } = action.data;
        draft.data = data;
        draft.isLoading = false;
        break;
      }
      case UPDATE_TABLE_DATA: {
        const {
          totalCount,
          hasPrevEnabled,
          hasNextEnabled,
          currentPageRowData,
        } = action.data;
        draft.totalCount = totalCount;
        draft.hasPrev = hasPrevEnabled;
        draft.hasNext = hasNextEnabled;
        draft.currentPageRowData = currentPageRowData;
        break;
      }
      case RESET_FILTERS: {
        const { filters, filtersForDisplay } = getDefaultFilterState();
        draft.filters = filters;
        draft.filtersForDisplay = filtersForDisplay;
        break;
      }
      case UPDATE_FILTERS: {
        const {
          activeNavigation,
          dateFilters,
          appliedFilters = {},
          filtersForDisplay = [],
          ...filters
        } = action.data;

        if (appliedFilters) draft.filters.appliedFilters = appliedFilters;
        if (dateFilters) draft.filters.dateFilters = dateFilters;

        draft.filters = {
          ...draft.filters,
          ...filters,
        };

        if (filtersForDisplay) draft.filtersForDisplay = filtersForDisplay;
        break;
      }
      case RESET_PAGE: {
        draft.filters.pageNo = DEFAULT_CURRENT_PAGE;
        break;
      }
      case SAVE_VENDOR_DATA_BY_ID: {
        draft.vendorIdData = action.data;
        break;
      }
      case ENABLE_LOADER: {
        draft.isLoading = true;
        break;
      }
      case DISABLE_LOADER: {
        draft.isLoading = false;
        break;
      }
      case DEFAULT_ACTION:
        break;
    }
  });

export default adjustmentsReducer;
